import React from "react";
import Version from "./Version";
import SocialLinks from "./SocialLinks";
const FooterText = () => {
  return (
    <div>
      <SocialLinks/>
      <Version/>
    </div>
  );
};

export default FooterText;
